export default __webpack_public_path__ + "static/countdown-3cda838b5f957e959f7d26c734fc78c2.gif";